import api from '@/api'
import notifier from '@/notifier'
import { merge } from 'lodash'

export default {
  namespaced: true,
  state: {
    total: 0,
    productsMigration: [],
    fetching: false,
    lastFetchOptions: null
  },
  actions: {
    async fetchProductsMigration ({ state, commit, getters }, { type, identifier, options, account }) {
      commit('fetching')

      try {
        const { total, items } = await api.getProductsMigration(type, identifier, options, account)

        commit('setFetchData', {
          items, total, options
        })
      } catch (error) {
        notifier.error('Falha ao buscar os produtos para migração.', 'Erro')
      }
    },
    async fetchMoreProductsMigration ({ state, commit, getters }, { type, identifier, options, account }) {
      commit('fetching')

      try {
        const { total, items } = await api.getProductsMigration(type, identifier, options, account)

        for (let i in items) {
          state.productsMigration.push(items[i])
        }

        state.total = total
      } catch (error) {
        options.finished = true
        notifier.error('Falha ao buscar os produtos para migração.', 'Erro')
      }
    },
    async clearProductsMigration ({ state, commit }) {
      const items = []
      commit('setFetchData', {
        items
      })
    }
  },
  getters: {
    getAccount: state => identifier => state.productsMigration.find(account => account.identifier === identifier)
  },
  mutations: {
    setFetchData (state, { items, total, options }) {
      state.total = total
      state.productsMigration = items
      state.lastFetchOptions = {...options}
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    },
    setItem (state, newItem) {
      const item = state.productsMigration.find(item => item.identifier === newItem.identifier)
      if (item) {
        merge(item, newItem)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/productMigration.js